'use client';
import Button from '@/components/ui/Button';
import { Bookmark } from 'lucide-react';
import { toast } from 'react-toastify';
import { AuthTokenStorageService } from '@/lib/auth';
import { useSavedJobIds, useSaveJob } from '@/features/jobs';

type Props = { jobId: number };
const JobSaveButton = (props: Props) => {
  const { jobId } = props;
  const { data: savedJobIds = [] } = useSavedJobIds();
  const isBookmarked = savedJobIds.some(
    (id) => Number(id) === Number(jobId)
  );
  const { mutate: saveJob, isPending } = useSaveJob();
  const onBookmarkClicked = (
    event: React.MouseEvent<HTMLButtonElement>,
    jobId: number
  ) => {
    event.preventDefault();
    event.stopPropagation();
    if (!AuthTokenStorageService.getAccessToken()) {
      toast.warning('Та нэвтэрч орсны дараа хадгалах боломжтой.');
      return;
    }
    if (isPending) return;
    saveJob(jobId);
  };
  return (
    <Button
      variant={'outline'}
      className="border border-none rounded-lg h-10 text-white hover:text-black group p-2"
      onClick={(event) => onBookmarkClicked(event, jobId)}
    >
      <Bookmark
        color="currentColor"
        size={20}
        fill={isBookmarked ? 'currentColor' : 'none'}
        className={`${isBookmarked ? 'text-secondary' : 'text-[#28282D]'} group-hover:text-secondary transition-all duration-200 ease-in-out shrink-0`}
      />
    </Button>
  );
};

export default JobSaveButton;
